export default __webpack_public_path__ + "images/cancerfondsrapporten/icon-food.png";